import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Clock } from "lucide-react";

/** v209 — Avg working hours between takes, per linked item. */
const MachineTakeStats = ({ machineId }) => {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    api.get(`/machines/${machineId}/take-stats`).then(({ data }) => setRows(data)).catch(() => setRows([]));
  }, [machineId]);
  if (!rows || rows.length === 0) return null;
  return (
    <div className="px-5 pt-4" data-testid="machine-take-stats">
      <div className="label-eyebrow flex items-center gap-1 mb-2">
        <Clock size={12} strokeWidth={2.5} /> Average hours between takes
      </div>
      <div className="flex flex-col gap-1">
        {rows.map((r) => (
          <div
            key={r.stock_id}
            data-testid={`machine-take-stat-${r.stock_id}`}
            className="nb-card-sm px-3 py-2 flex items-center gap-3 text-sm"
          >
            <div className="flex-1 min-w-0 truncate font-bold">{r.stock_name || "Linked item"}</div>
            <div className="text-[11px] text-[#607087] shrink-0">
              {r.takes} take{r.takes === 1 ? "" : "s"}
              {r.last_interval != null && ` · last ${r.last_interval} h`}
            </div>
            <div className="font-mono-num font-bold shrink-0 w-24 text-right">
              {r.avg_hours_between != null ? `${r.avg_hours_between} h` : "—"}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MachineTakeStats;
